import axios from 'axios';
import { PublicProfileData } from './types';
import { apiCall } from '@shared/entity';

const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

export type TimeSlot = { start: string; end: string };
export type DayAvailability = 'morning' | 'afternoon' | 'both' | null;

export type CreateReservationPayload = {
  serviceId: string;
  requestedDate: string;
  requestedDateTo: string;
  customerFirstName: string;
  customerLastName: string;
  customerPhone: string;
  customerPhonePrefix: string;
  customerEmail?: string;
  note?: string;
  customerPhotos?: string[];
};

export const fetchPublicProfile = (userId: string): Promise<PublicProfileData> =>
  apiCall(
    () =>
      publicApi.get<PublicProfileData>(
        `/api/public-reservations/profile/${encodeURIComponent(userId)}`,
      ),
    'api.publicReservation.fetchProfileError',
  );

export const fetchPublicAvailableSlots = (
  userId: string,
  date: string,
  serviceId: string,
): Promise<{ slots: TimeSlot[]; reason?: string }> =>
  apiCall(
    () =>
      publicApi.get(
        `/api/public-reservations/profile/${encodeURIComponent(userId)}/available-slots`,
        { params: { date, serviceId } },
      ),
    'api.publicReservation.fetchSlotsError',
  );

export const fetchPublicHighlightedDays = (
  userId: string,
  month: string,
  serviceId: string,
): Promise<{ days: Record<string, DayAvailability> }> =>
  apiCall(
    () =>
      publicApi.get(
        `/api/public-reservations/profile/${encodeURIComponent(userId)}/highlighted-days`,
        { params: { month, serviceId } },
      ),
    'api.publicReservation.fetchHighlightedDaysError',
  );

export const createPublicReservation = (
  userId: string,
  payload: CreateReservationPayload,
): Promise<{ id: string }> =>
  apiCall(
    () =>
      publicApi.post(
        `/api/public-reservations/profile/${encodeURIComponent(userId)}/reserve`,
        payload,
      ),
    'api.publicReservation.createError',
  );
